import React, { Fragment } from 'react';

const NewWheelchairPt1 = () => (
  <Fragment>
    <h4>Equipment</h4>
    <p className="new-course__body__content__para">
      Check you have the required equipment in good working order before accepting passengers; Four retractors with
      ‘J-shaped Hooks’, one lap belt, one shoulder belt.
    </p>
    <h4>Vehicle entry</h4>
    <ol className="new-course__body__content__olist">
      <li>
        Make sure the vehicle door is latched in the open position. Position the ramp firmly and flat on the surface of
        the sidewalk or road.
      </li>
      <li>
        If requested, push the person using a wheelchair up the ramp. Stand behind the wheelchair, facing the car, stay
        close and avoid jerky movements.
      </li>
      <li>
        Once inside the accessible vehicle, position the passenger facing forward, centered in the securement area to be
        ready for wheelchair securement. Lock the wheelchair.
      </li>
    </ol>

    <hr />
    <h4>Securing your passenger using a wheelchair</h4>
    <ol className="new-course__body__content__olist">
      <li>
        Place & lock the wheelchair
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Position the person facing forward in the center of the securement area, protecting their feet from hitting
            the wall or back of the seat.
          </li>
          <li>Ask the passenger to lock the wheelchair brakes or power off, and assist if requested.</li>
        </ul>
      </li>
      <li>
        Attach 4 retractors to the floor
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Attach two retractors to both the back and front of the floor tracks in the order that’s easiest for you.
            The rear retractors should be inside or narrower than the wheels. The front retractors should be placed
            slightly outside or wider than the width of the chair for side stability.
          </li>
          <li>
            Lock the retractors to the floor tracking by lining up the grooves on the retractor with those on the floor.
            Press down and slide until it clicks. The red indicators lining up show that it is correctly locked and you
            can pull on the retractor to make sure it is secure.
          </li>
        </ul>
      </li>
      <li>
        Attach the hooks to the wheelchair
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Pull the ‘J hooks’ out of the retractors and attach them in a straight line to a solid part of the
            wheelchair frame close to the seat.
          </li>
          <li>It is best to ask the person where to best attach the retractors.</li>
          <li>
            You should not attach them to unstable points like the wheels, removable armrests or footrests or bend them
            around any part of the chair.
          </li>
          <li>The attached hooks should roughly make a 30-45 degree angle with the floor.</li>
        </ul>
      </li>
      <li>
        Increase the tension on the wheelchair{' '}
        <ul className="new-course__body__content__olist--ulist">
          <li>If the person is using a manual wheelchair, ask permission to move the passenger’s wheelchair.</li>
          <li>
            If the person is using a power wheelchair, ask the passenger to move back and forth and power off again.
          </li>
        </ul>
      </li>
    </ol>

    <hr />
    <h4>Securing your passenger using a wheelchair: Lap/Shoulder Belts</h4>
    <ol className="new-course__body__content__olist">
      <li>
        <h5>Attach the lap belt</h5>
        <ul className="new-course__body__content__olist--ulist">
          <li>
            First ask the passenger if they would like assistance with the lap and shoulder belt for their safety, e.g.
            "Is it okay if I put the belt on?"
          </li>
          <li>
            Place the lap belt low on the front pelvis of the passenger and wrap it around the passenger’s body so both
            ends feed behind the wheelchair.
          </li>
          <li>
            The belt must never go over or around the armrest as it needs to lay directly on the passenger’s body. The
            buckle should be on the same side as the ramp.
          </li>
          <li>Attach the ends of the belt to the metal knobs on the corresponding back retractors.</li>
        </ul>
      </li>
      <li>
        Attach the shoulder belt
        <ul className="new-course__body__content__olist--ulist">
          <li>
            Make sure the shoulder belt is attached to the anchor on the wall of the vehicle. It should be slightly
            higher and behind the passengers shoulder.
          </li>
          <li>
            Bring the shoulder belt over the middle of the passengers shoulder and attach it to the metal nob on the lap
            belt buckle.
          </li>
        </ul>
      </li>
      <li>
        Tighten both belts
        <ul className="new-course__body__content__olist--ulist">
          <li>Tighten both the seat and shoulder belt snugly, leaving a 2 finger gap.</li>
          <li>It should be tight enough not to easily slip off.</li>
        </ul>
      </li>
    </ol>
  </Fragment>
);
export default NewWheelchairPt1;



// WEBPACK FOOTER //
// ./src/components/NewCourse/NewWheelchairPt1.js